<template>
  <div class="chart-tooltip" v-if="item">
    <div class="item-name">{{item.name}}</div>
    <div class="item-value">
      <label>Emissions: </label>
      <span class="value">{{item.realValue.toFixed(2)}}</span>
    </div>
    <div class="item-transformation" v-if="item.transformValue">
      <label>Transformation: </label>
      <span class="value">{{item.transformValue.toFixed(2)}}</span>
      <div class="trans-note">
        <span>{{item.transformDescription}}</span>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'ChartTooltip',
  props: ['item', 'type'],
  methods: {
  }
}
</script>

<style lang="stylus" scoped>
.chart-tooltip
  .tooltip-content
    align-items: center
    display: flex
  .item-name
    font-size 18px
  .value
    font-weight bold
  .item-value
    margin-top 7px
  .item-transformation
    margin-top 7px
    .trans-note
      font-size 10px
</style>
